<template>
   <div>
      <AuthorOpinionsList v-if="isEmpty(tail($route.params.query_params))" :author-slug="head($route.params.query_params)"/>
      <AuthorOpinion v-else/>
     
   </div>
</template>

<script setup lang="ts">
   import {isEmpty, head, tail} from 'lodash-es';
   import AuthorOpinionsList from '~/components/Opinions/AuthorOpinionsList.vue';
   import AuthorOpinion from '~/components/Opinions/AuthorOpinion.vue';
</script>


<style scoped>

</style>